export default {"src":"/_next/static/media/heart_40.af7527cd.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};